var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"context"}},[_c('remote-script',{attrs:{"src":'https://webapi.amap.com/maps?v=1.4.12&key=4bde7b8be905b4e172bfd5bfcadbda18&plugin=AMap.Walking'}}),_vm._v(" "),_c('div',{attrs:{"id":"container"}}),_vm._v(" "),_c('div',{attrs:{"id":"panel"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-457e1d4b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/WeChat/Map/index.vue
// module id = null
// module chunks = 